enum Root {
  Account = "/account",
  Commerce = "/commerce",
  Community = "/community",
  Legal = "/legal",
  System = "/system",
  About = "/about",
  Store = "/store",
  SARChecker = "/sar-checker",
}

enum Magento {
  Store = "https://store.mudita.com",
}

export enum Forum {
  Home = "https://forum.mudita.com/",
  SSO = "https://forum.mudita.com/session/sso",
}

export enum Path {
  /* General */
  Home = "" + "/",
  /* System */
  Redirect = Root.System + "/redirect/",
  ChooseCountry = Root.System + "/choose-country/",
  /* Products */
  Products = "" + "/products/",
  /* Legal */
  PrivacyPolicy = Root.Legal + "/privacy-policy/",
  TermsEn = Root.Legal + "/terms/eng/",
  TermsPl = Root.Legal + "/terms/pl/",
  TermsOfSaleEn = Root.Legal + "/terms-of-sale/eng",
  TermsOfSalePL = Root.Legal + "/terms-of-sale/pl",
  /* Account */
  Login = Root.Account + "/login/",
  Orders = Root.Account + "/orders/",
  OrderDetails = Root.Account + "/orders/:id",
  /* Commerce */
  Cart = Root.Commerce + "/cart/",
  CheckoutAddress = Root.Commerce + "/checkout/address/",
  CheckoutDelivery = Root.Commerce + "/checkout/delivery/",
  CheckoutPayment = Root.Commerce + "/checkout/payment/",
  CheckoutConfirm = Root.Commerce + "/checkout/confirm/",
  CheckoutComplete = Root.Commerce + "/checkout/complete/",
  /* Community */
  SarChecker = Root.Community + "/sar-checker/",
  Blog = Root.Community + "/blog/",
  /* About */
  Media = Root.About + "/media/",
  MediaLibrary = Path.Media + "media-library/",
  Contact = Root.About + "/contact/",
  /* Store */
  Store = Root.Store + "/",
  Checkout = Root.Store + "/checkout/",
  ThankYou = Root.Store + "/thank-you/",
  MuditaPureStore = Root.Store + "/mudita-pure-minimalist-phone/",
  /* SAR Checker */
  SARMuditaPure = Root.SARChecker + "/mudita-pure",
}

export enum MagentoPath {
  Orders = Magento.Store + "/sales/order/history/",
  Cart = Magento.Store + "/checkout/cart/",
  Account = Magento.Store + "/customer/account/",
  Address = Magento.Store + "/customer/address/new/",
}
